import { saveClientData as saveClientDataApi } from '../api';
import { Env } from '@/shared/config/environment';
import { createPersistence } from '@/shared/lib/store';

const { createAccessor, defineMutation } = createPersistence('client-');
const storage = createAccessor();

const state = {
  client: {
    regular: storage.get('client-regular', false),
    individualEntrepreneur: storage.get('client-individual-entrepreneur', false),
  },
};

const mutations = {
  SET_CLIENT_REGULAR: defineMutation('client.regular', 'client-regular', false),
  SET_CLIENT_INDIVIDUAL_ENTREPRENEUR: defineMutation('client.individualEntrepreneur', 'client-individual-entrepreneur', false),
  CLEAR_ALL(state) {
    state.client.regular = false;
    state.client.individualEntrepreneur = false;
  },
};

const actions = {
  async saveClientData({ dispatch }, clientData) {
    try {
      return await saveClientDataApi(clientData);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося зберегти дані клієнта';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error,
          title: 'Не вдалося зберегти дані клієнта',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    }
  },
  setClientRegular({ commit }, isRegular) {
    commit('SET_CLIENT_REGULAR', isRegular);
  },
  setClientIndividualEntrepreneur({ commit }, isIndividualEntrepreneur) {
    commit('SET_CLIENT_INDIVIDUAL_ENTREPRENEUR', isIndividualEntrepreneur);
  },

  clear({ commit }) {
    commit('CLEAR_ALL');
  },
};

const getters = {
  isClientRegular: state => state.client.regular,
  isClientIndividualEntrepreneur: state => state.client.individualEntrepreneur,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
